'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_ERROR_SNACKBAR = exports.SET_SUCCESS_SNACKBAR = exports.SET_MESSAGE = exports.SET_SNACKBAR = undefined;
exports.setSnackBar = setSnackBar;
exports.setSuccessSnackBar = setSuccessSnackBar;
exports.setErrorSnackBar = setErrorSnackBar;
exports.setMessage = setMessage;
exports.onRequestClose = onRequestClose;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_SNACKBAR = exports.SET_SNACKBAR = 'SET_SNACKBAR';
var SET_MESSAGE = exports.SET_MESSAGE = 'SET_MESSAGE';
var SET_SUCCESS_SNACKBAR = exports.SET_SUCCESS_SNACKBAR = 'SET_SUCCESS_SNACKBAR';
var SET_ERROR_SNACKBAR = exports.SET_ERROR_SNACKBAR = 'SET_ERROR_SNACKBAR';

// TODO : eliminare dipendenze intl

var successMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'SUCCESS',
  description: 'Notify success of an operation',
  defaultMessage: 'Operation executed successfully'
});

var errorMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
  id: 'ERROR',
  description: 'Notify a generic error',
  defaultMessage: 'Error. Unable to perform requested operation'
});

function setSnackBar(snackBar) {
  return {
    type: SET_SNACKBAR,
    payload: snackBar
  };
}

function setSuccessSnackBar() {
  return setSnackBar({
    message: successMessage,
    show: true
  });
}

function setErrorSnackBar() {
  return setSnackBar({
    message: errorMessage,
    show: true
  });
}

function setMessage(message) {
  return {
    type: SET_MESSAGE,
    payload: message
  };
}

function onRequestClose() {
  return setSnackBar({
    message: '',
    show: false
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/SnackBarContainer/actions.js
 ** module id = 97
 ** module chunks = 0
 **/